import { render, staticRenderFns } from "./BookingPositionJobandTalentUpdate.vue?vue&type=template&id=44c00a62&"
import script from "./BookingPositionJobandTalentUpdate.vue?vue&type=script&lang=js&"
export * from "./BookingPositionJobandTalentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports